const SidebarItems = [
    {
        name: "Dashboard",
        route: '/network'
    },
    {
        name: "Books",
        route: '/network-books'
    },
    {
        name: "Film",
        route: '/network-film'
    },
    {
        name: "Music",
        route: '/network-music'
    },
    {
        name: "TV",
        route: '/network-tv'
    },
];

export default SidebarItems;
